import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { crearContacto } from "../../services/ContactosService";

import '../static/Aboutus.css';
import '../static/Perfil.css';
import '../static/Global.css';

function AboutUs() {
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);

    const data = {
        fullName: formData.get("fullName"),
        numCel: formData.get("numCel"),
        description: formData.get("description")
    };

    await crearContacto(data);

    setShowModal(true);
    event.target.reset();
};


    const handleCloseModal = () => {
        setShowModal(false);
        // En React usamos navigate en lugar de window.location.href
        // para no recargar toda la aplicación
        navigate('/aboutus'); 
    };

    return (
        <main className="main__section">
            <h1 className="main__title">Contáctanos</h1>

            <article className="container py-2">
                <form className="review-card container-xxl p-4 p-md-5" onSubmit={handleSubmit}>
                    <div className="row g-4 align-items-start">
                        
                        <div className="col-12 col-md-6">
                            <label htmlFor="fullName" className="form-label fw-semibold label-dark">
                                Nombre y Apellidos:
                            </label>
                            <input 
                                id="fullName" 
                                name="fullName" 
                                type="text" 
                                className="form-control pill-input" 
                                placeholder="Juan Perez" 
                                required 
                            />
                        </div>

                        <div className="col-12 col-md-6">
                            <label htmlFor="numCel" className="form-label fw-semibold label-dark">
                                Número telefónico:
                            </label>
                            <input 
                                id="numCel" 
                                name="numCel" 
                                type="text" 
                                className="form-control pill-input" 
                                placeholder="+51 999 999 999" 
                                required 
                            />
                        </div>

                        <div className="col-12">
                            <label htmlFor="description" className="form-label fw-semibold label-dark">
                                Descripción:
                            </label>
                            <textarea 
                                id="description" 
                                name="description" 
                                rows="5" 
                                className="form-control soft-area" 
                                placeholder="Escribe tu hermoso pedido..." 
                                required
                            ></textarea>
                        </div>

                        <div className="col-12 d-flex justify-content-end">
                            <button type="submit" className="pill-btn px-4 py-2">
                                ENVIAR PETICIÓN <i className="fa-solid fa-angle-right"></i>
                            </button>
                        </div>
                    </div>
                </form>
            </article>


<section className="container mt-5 pb-5">
    <div className="row g-4">
        
        {/* COLUMNA: SOBRE NOSOTROS */}
        <div className="col-12 col-md-4">
            <div className="p-4 info-card shadow-sm rounded">
                <h3 className="fw-bold mb-3"><i className="fa-solid fa-rocket me-2"></i>Nuestra Misión</h3>
                <p className="text-muted-custom">
                    En <strong>YCore Studio</strong>, nos dedicamos a ofrecer soluciones innovadoras para impulsar 
                     y mejorar tu negocio, con asesoramiento experto y un servicio al cliente excepcional.
                </p>
            </div>
        </div>

        {/* COLUMNA: UBICACIÓN */}
        <div className="col-12 col-md-4">
            <div className="p-4 info-card shadow-sm rounded">
                <h3 className="fw-bold mb-3"><i className="fa-solid fa-location-dot me-2"></i>Ubicación</h3>
                <p className="text-muted-custom">
                    Puedes encontrarnos en Lima - Lima - Comas - Av. Tupac Amaru 3436.
                </p>
            </div>
        </div>

        {/* COLUMNA: REDES Y CONTACTO DIRECTO */}
        <div className="col-12 col-md-4">
            <div className="p-4 info-card shadow-sm rounded">
                <h3 className="fw-bold mb-3"><i className="fa-solid fa-share-nodes me-2"></i>Síguenos</h3>
                <div className="d-flex flex-column gap-2">
                    <a href="https://www.facebook.com/profile.php?id=100089989401567" className="social-link"><i className="fa-brands fa-facebook me-2"></i> Facebook</a>
                    <a href="https://www.instagram.com/novatechzz/" className="social-link"><i className="fa-brands fa-instagram me-2"></i> Instagram</a>
                    <a href="https://www.tiktok.com/@novatechzz" className="social-link"><i className="fa-brands fa-tiktok me-2"></i> Tiktok</a>
                    <a href="https://api.whatsapp.com/send?phone=51906145083&text=Saludos!%20Quisiera%20ponerme%20en%20contacto%20con%20un%20asesor." className="social-link"><i className="fa-brands fa-whatsapp me-2"></i> WhatsApp</a>
                </div>
            </div>
        </div>

    </div>
</section>


            {/* MODAL DE ÉXITO */}
            {showModal && (
                <div 
                    id="modalExito" 
                    className="modal" 
                    style={{ display: 'flex', backgroundColor: 'rgba(0,0,0,0.5)' }}
                    onClick={handleCloseModal}
                >
                    <div className="modal-content text-center" onClick={(e) => e.stopPropagation()}>
                        <h2 className="fw-bold mb-3">¡Petición Enviada!</h2>
                        <p>Hemos recibido tus datos correctamente. Nos pondremos en contacto contigo pronto.</p>
                        <button 
                            type="button" 
                            className="pill-btn px-4 mt-3" 
                            onClick={handleCloseModal}
                        >
                            ENTENDIDO
                        </button>
                    </div>
                </div>
            )}
        </main>
    );
}

export default AboutUs;